var map = {
	"./vaso-cafetero.webp": 6658,
	"./vaso-coloreable.webp": 2189,
	"./vaso-high-gloss.webp": 2264,
	"./vaso-liso-brillante.webp": 3080,
	"./vaso-metalizado.webp": 9405,
	"./vaso-orange-peel.webp": 3914,
	"./vaso-termocrom tico.webp": 8480,
	"./vaso-termocromático.webp": 1139,
	"./vaso-transparente.webp": 3190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6853;